import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiPostman,
  SiSwagger,
  SiApachejmeter,
  SiK6,
  SiGit,
  SiGithub,
  SiJenkins,
  SiGithubactions,
  SiJira,
  SiClickup,
  SiNotion,
  SiMicrosoftexcel,
  SiVisualstudiocode,
  SiGooglechrome,
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {/* API & Performance Testing */}
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Postman</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSwagger />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Swagger</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiApachejmeter />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>JMeter</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiK6 />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>k6</p>
      </Col>

      {/* Version Control & CI/CD */}
      <Col xs={4} md={2} className="tech-icons">
        <SiGit />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Git</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGithub />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>GitHub</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiJenkins />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Jenkins</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGithubactions />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>GitHub Actions</p>
      </Col>

      {/* Test & Project Management */}
      <Col xs={4} md={2} className="tech-icons">
        <SiJira />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>JIRA</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiClickup />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>ClickUp</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNotion />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Notion</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMicrosoftexcel />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Excel</p>
      </Col>

      {/* Dev Tools */}
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>VS Code</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGooglechrome />
        <p style={{ fontSize: "0.3em", marginTop: "10px" }}>Chrome DevTools</p>
      </Col>
    </Row>
  );
}

export default Toolstack;